import axiosInstance from "./axios";
import {AxiosRequestConfig} from "axios";

export const getFetcher = async <T>(url: string, config?: AxiosRequestConfig): Promise<T> => {
    const response = await axiosInstance.get<T>(url, config);
    return response.data;
}

export const postFetcher = async <TRequest, TResponse>(
    url: string,
    data: TRequest,
    config?: AxiosRequestConfig
): Promise<TResponse> => {
    const response = await axiosInstance.post<TResponse>(url, data, config);
    return response.data;
}

export const putFetcher = async <TRequest, TResponse>(
    url: string,
    data: TRequest,
    config?: AxiosRequestConfig
): Promise<TResponse> => {
    const response = await axiosInstance.put<TResponse>(url, data, config);
    return response.data;
}

export const deleteFetcher = async <T>(url: string, config?: AxiosRequestConfig): Promise<T> => {
    const response = await axiosInstance.delete<T>(url, config);
    return response.data;
}